import React, { useEffect } from 'react';
import { siteUrl } from '../../config';

const CafeSolutionPage = () => {
  useEffect(() => {
    document.title = 'Cafe Otomasyonu | Kafe Çözümü | QR Menü, POS, Online Sipariş, Kurye, Yapay Zeka';
    const meta = document.querySelector('meta[name="description"]') || (() => {
      const m = document.createElement('meta');
      m.setAttribute('name', 'description');
      document.head.appendChild(m);
      return m;
    })();
    meta.setAttribute('content', 'Kafeler için QR menü, POS, online sipariş, kurye takibi ve yapay zeka ile uçtan uca dijital çözüm. QR Menü ücretsiz; AI 15 gün, diğer modüller 30 gün ücretsiz.');

    const structured = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      name: 'Kafe Dijital Çözümü',
      serviceType: 'Kafe Otomasyon Sistemi',
      areaServed: 'TR',
      provider: {
        '@type': 'Organization',
        name: 'Cafe Otomasyonu'
      },
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'TRY',
        description: 'QR Menü ücretsiz; diğer modüller deneme süresiyle birlikte.'
      }
    };
    // Canonical
    const canonicalHref = `${siteUrl}/solutions/cafe`;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', canonicalHref);

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(structured);
    document.head.appendChild(script);
    return () => {
      if (script && script.parentNode) document.head.removeChild(script);
      if (canonical && canonical.parentNode && canonical.getAttribute('href') === canonicalHref) {
        document.head.removeChild(canonical);
      }
    };
  }, []);

  return (
    <main className="bg-white">
      <section className="py-16 md:py-24 bg-gradient-to-br from-gray-50 to-white">
        <div className="max-w-5xl mx-auto px-4">
          <h1 className="font-poppins font-heading-bold text-3xl md:text-5xl text-foreground mb-4">Kafeler için Dijital Çözüm</h1>
          <p className="font-open-sans text-lg text-text-secondary mb-8">QR Menü (sürekli ücretsiz), POS, Online Sipariş, Kurye ve Yapay Zeka modülleriyle kafenizi uçtan uca yönetin. Hızlı kurulum, komisyonsuz sipariş ve güçlü raporlama.</p>
          <div className="flex flex-wrap gap-3 mb-10">
            <a href="https://panel.cafeotomasyonu.com/sign-up" className="px-6 py-3 rounded-lg bg-primary text-white font-poppins font-heading-semibold">Ücretsiz Kayıt Ol</a>
            <a href="https://menu.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">QR Menü Demo</a>
            <a href="https://online.cafeotomasyonu.com/demo" className="px-6 py-3 rounded-lg border border-primary text-primary font-poppins font-heading-semibold" rel="nofollow">Online Sipariş Demo</a>
          </div>
          <div className="grid md:grid-cols-2 gap-6">
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Öne Çıkanlar</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü daima ücretsiz, sınırsız ürün/kategori</li>
                <li>Komisyonsuz online sipariş, teslimat/gel-al akışı</li>
                <li>POS ile masa–kasa yönetimi, yazıcı entegrasyonu</li>
                <li>Kurye haritası, canlı konum ve teslimat performansı</li>
                <li>Yapay Zeka ile menü/satış optimizasyonu</li>
              </ul>
            </div>
            <div className="p-6 rounded-xl border border-gray-200 bg-white">
              <h2 className="font-poppins font-heading-semibold text-xl mb-3">Deneme Süreleri</h2>
              <ul className="list-disc pl-5 space-y-2 text-text-secondary">
                <li>QR Menü: Süresiz ücretsiz</li>
                <li>Yapay Zeka: 15 gün ücretsiz</li>
                <li>POS / Online Sipariş / Kurye: 30 gün ücretsiz</li>
              </ul>
            </div>
          </div>

          <section className="mt-10 space-y-6 text-text-secondary">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground">Kafeler İçin Uygun Modüller</h2>
            <p>
              Kafe operasyonları; masa döngüsü, içecek ve atıştırmalık çeşitliliği, yoğun saatlerde hız ve
              müşteri deneyimi gerektirir. Aşağıdaki modüller, kafe iş akışını hızlandırır ve satışları artırır:
            </p>
            <h3 className="font-poppins font-heading-semibold text-xl">QR Menü</h3>
            <p>
              Masalara özel <a className="text-primary underline" href="/qr-menu">QR Menü</a> ile temassız, anlık güncellenen
              menüler sunun. Ürün görselleri ve alerjen etiketleri ile siparişe giden yolu kısaltın.
            </p>
            <h3 className="font-poppins font-heading-semibold text-xl">Online Sipariş</h3>
            <p>
              Komisyonsuz <a className="text-primary underline" href="/online-order">Online Sipariş</a> modülüyle gel-al ve teslimat akışını
              yönetin; bölge, servis saatleri ve minimum sepet sınırlarını panelden ayarlayın.
            </p>
            <h3 className="font-poppins font-heading-semibold text-xl">POS Sistemi</h3>
            <p>
              <a className="text-primary underline" href="/pos-system">POS</a> ile masa/sipariş yönetimi, indirim–ikram, çoklu yazıcı,
              gün sonu raporları ve yoğun saatlerde hızlı arayüz ile kesintisiz hizmet verin.
            </p>
            <h3 className="font-poppins font-heading-semibold text-xl">Kurye Takip</h3>
            <p>
              Paket servis yapan kafeler için <a className="text-primary underline" href="/courier-system">Kurye</a> uygulamasıyla canlı
              konum, rota ve performans takibini tek ekranda görün.
            </p>
            <h3 className="font-poppins font-heading-semibold text-xl">Yapay Zeka</h3>
            <p>
              <a className="text-primary underline" href="/ai-system">AI</a> ile ürün kârlılık analizi, menü optimizasyonu, talep tahmini
              ve çapraz satış önerileri alın. Az satan ürünleri tespit edip menünüzü güçlendirin.
            </p>
          </section>

          <section className="mt-10">
            <h2 className="font-poppins font-heading-bold text-2xl text-foreground mb-4">Sıkça Sorulan Sorular</h2>
            <div className="space-y-4">
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">QR Menü ücretli mi?</summary>
                <p className="mt-2">Hayır. QR Menü modülü daima ücretsizdir ve sınırsız ürün/kategori destekler.</p>
              </details>
              <details className="group border border-gray-200 rounded-xl p-5 bg-gray-50">
                <summary className="font-poppins font-heading-semibold cursor-pointer">Kafeler için hangi modüller önerilir?</summary>
                <p className="mt-2">POS, Online Sipariş, Kurye ve AI modüllerini birlikte kullanarak en yüksek verimi elde edebilirsiniz.</p>
              </details>
            </div>
          </section>
        </div>
      </section>
    </main>
  );
};

export default CafeSolutionPage;


